import { ThemeEvents } from '@theme/events';

const drawer = document.querySelector('[data-cart-added-drawer]');
const panel = drawer?.querySelector('.mexo-cart-added-drawer__panel');
const image = drawer?.querySelector('[data-cart-added-image]');
const closeControls = drawer?.querySelectorAll('[data-cart-added-close]');

let lastFocusedElement = null;
let closeTimer;

const normalizeImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('//')) return `${window.location.protocol}${url}`;
  return url;
};

const getSourceForm = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return null;

  if (target.matches('product-form-component')) return target;
  return target.closest('product-form-component');
};

const getAddedItem = (event) => {
  const { resource, sourceId, data } = event.detail || {};
  const items = Array.isArray(resource?.items) ? resource.items : [];

  if (!items.length) return null;

  const variantId = data?.variantId || sourceId;
  const productId = data?.productId;

  return (
    items.find((item) => variantId && String(item.variant_id) === String(variantId)) ||
    items.find((item) => productId && String(item.product_id) === String(productId)) ||
    items[0]
  );
};

const getImageUrl = (event, item) => {
  const form = getSourceForm(event);
  const addToCart = form?.querySelector('add-to-cart-component');
  const variantMedia = addToCart?.dataset.productVariantMedia;
  const itemImage = item?.featured_image?.url || item?.image;

  return normalizeImageUrl(itemImage || variantMedia || '');
};

const setImage = (event, item) => {
  if (!(image instanceof HTMLImageElement)) return;

  const imageUrl = getImageUrl(event, item);
  const imageAlt = item?.featured_image?.alt || item?.product_title || item?.title || '';

  if (!imageUrl) {
    image.hidden = true;
    image.removeAttribute('src');
    image.alt = '';
    return;
  }

  image.src = imageUrl;
  image.alt = imageAlt;
  image.hidden = false;
};

const openDrawer = (event) => {
  if (!drawer) return;

  const item = getAddedItem(event);
  setImage(event, item);

  window.clearTimeout(closeTimer);
  lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  drawer.hidden = false;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('mexo-cart-added-drawer-open');

  window.requestAnimationFrame(() => {
    drawer.classList.add('is-open');
    panel?.focus({ preventScroll: true });
  });
};

const closeDrawer = () => {
  if (!drawer || drawer.hidden) return;

  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('mexo-cart-added-drawer-open');

  closeTimer = window.setTimeout(() => {
    drawer.hidden = true;
    if (lastFocusedElement?.isConnected) {
      lastFocusedElement.focus({ preventScroll: true });
    }
  }, 280);
};

const handleCartUpdate = (event) => {
  const detail = event.detail || {};

  if (detail.data?.didError) return;
  if (detail.data?.source !== 'product-form-component') return;

  openDrawer(event);
};

const handleDocumentKeydown = (event) => {
  if (event.key === 'Escape') closeDrawer();
};

drawer?.addEventListener('click', (event) => {
  if (event.target === drawer) closeDrawer();
});

closeControls?.forEach((control) => {
  control.addEventListener('click', closeDrawer);
});

document.addEventListener(ThemeEvents.cartUpdate, handleCartUpdate);
document.addEventListener('keydown', handleDocumentKeydown);
